/**
 * Gardes de l'ouvreur à l'arrivée `auto-open-modal` quand il porte `forgetParam`
 * (refonte de l'espace chantier V2, G-5, décision 08 : `?facture=<id>` / `?devis=<id>`
 * sur Suivi financier). Module pur, sans Stimulus ni Turbo : importable sous `node --test`.
 */

/**
 * L'URL sans le paramètre de recherche `name`, ou null s'il n'y figure pas (rien à
 * réécrire). Le fragment et les autres paramètres sont gardés.
 *
 * @param {string} href l'URL courante, absolue
 * @param {string} name le paramètre à retirer (`facture`, `devis`)
 * @returns {string|null}
 */
export function withoutSearchParam(href, name) {
  if (!name) return null;
  const url = new URL(href);
  if (!url.searchParams.has(name)) return null;
  url.searchParams.delete(name);
  return url.toString();
}

/**
 * Un aperçu Turbo (instantané du cache peint avant la réponse) : `html[data-turbo-preview]`.
 * Précédent `remark_auto_open_controller.js` (revue G7).
 *
 * @param {Document|undefined} doc
 * @returns {boolean}
 */
export function isTurboPreview(doc) {
  return doc?.documentElement?.hasAttribute?.('data-turbo-preview') === true;
}

/**
 * Une page préchargée par le navigateur (« prerender » des règles de spéculation) : le JS y
 * tourne avant que la personne n'y soit. `document.prerendering` repasse à false à
 * l'activation, signalée par `prerenderingchange`.
 *
 * @param {Document|undefined} doc
 * @returns {boolean}
 */
export function isPrerendering(doc) {
  return doc?.prerendering === true;
}
